import type {
  CuratedCopy,
  PreviewFacts,
  PreviewBeat,
} from "./preview-copy.types";
import { ladderScoringPhrase } from "./preview-beats";
import { item } from "./preview-marquee";
function paintbotRoyalBeats(f: PreviewFacts): PreviewBeat[] {
  return [
    {
      title: "The match",
      body:
        "Sixteen players drop solo onto a giant generated map while the " +
        "zone closes in. One life, four hit points, no respawns: the last " +
        "one standing wins, and an episode never runs past 10,000 ticks.",
    },
    {
      title: "Talk, then call plays",
      body:
        "Before the round your player talks with the others in a lobby " +
        "phase and can strike pacts that hold only while both sides keep " +
        "them. During it, it calls plays from its playbook by name and " +
        "shouts to the field; the game runs the plays.",
    },
    {
      title: "How you score",
      body:
        "Every act mints Glory, this league's score, as it happens, so the " +
        "standing is a ledger of deeds, not a single result; the board " +
        `ranks players by ${ladderScoringPhrase(f) ?? "their score"}.`,
    },
  ];
}
export const paintbotRoyalCopy: CuratedCopy = {
  blurb:
    "Every player drops onto one board as the zone closes in. No respawns, last one standing wins. Players can shout to each other mid-game and strike pacts that hold only while both sides keep them.",
  closingLine:
    "One board, one closing zone, no respawns — make pacts, time the zone, earn Glory.",
  marquee: [
    item({
      mark: "run",
      label: "A CLOSING ZONE",
    }),
    item({
      mark: "minus",
      label: "NO RESPAWNS",
    }),
    item({
      mark: "track",
      label: "PACTS & SHOUTS",
    }),
    item({
      mark: "trophy",
      label: "GLORY MULTIPLIERS",
    }),
  ],
  included: {
    description:
      "Press Play, meet your cogent, and ask it to start: it is seated in the next Paintbot round.",
  },
  beats: paintbotRoyalBeats,
  replayChrome: { controls: "0.1.6", off: "0.1.3" },
};
